import React from 'react';
import {HOST} from "../../settings";

const HeaderLogo = ({variant = 'default'}) => {
    const logoSrc = variant === 'white'
        ? 'assets/img/logo/new_whitelogo.png'
        : 'assets/img/logo/new_logo.png';

    return (
        <div className="header-logo">
            <a className="logo logo-secondary transform-scale-h" title="Logo" href={ HOST.PUBLIC_URL + "/" }>
                <img src={logoSrc} alt="Logo" />
            </a>
        </div>
    );
};

export default HeaderLogo;
